import http from '../http';
import { request_param_handle, response_param_handle, encryptPasswordField } from '../base';
import { getDeviceInfo } from '../http';

const AUTH_API = {
  // 登录
  login: (data) => http.post('/tax/auth/login', request_param_handle(data)),

  // 注册
  register: (data) => http.post('/tax/auth/register', request_param_handle(data)),

  // 发送注册验证码
  sendRegisterCode: (data) => http.post('/tax/auth/register/email/code', request_param_handle(data)),

  // 发送登录验证码
  sendLoginCode: (data) => http.post('/tax/auth/login/email/code', request_param_handle(data)),

  // 验证码登录
  codeLogin: (data) => http.post('/tax/auth/login/code', request_param_handle(data)),

  // 获取用户信息
  getUserProfile: () => http.get('/tax/user/profile'),
  
  // 刷新token
  refreshToken: (refreshToken) => http.post('/tax/auth/refresh-token', { refreshToken }),
  
  // 登出
  logout: () => http.post('/tax/auth/logout')
};

/**
 * User login API
 * @param {Object} param - Login parameters object containing email and password
 * @param {Function} callBack - Callback function after successful login
 */
export const login = async (param = {}, callBack) => {
    // 使用纯 RSA 加密密码
    const encryptedPassword = encryptPasswordField(param.password);

    const loginData = {
      email: param.email,
      password: encryptedPassword,
      device: getDeviceInfo()
    };

    await http.post(`/newapi/tax/auth/login`, loginData).then(({ data: res }) => {
      callBack && callBack(res);
    });
};

/**
 * Send email verification code before registration
 * @param {Object} param - Parameter object containing email
 * @param {Function} callBack - Callback function after successful code sending
 */
export const sendEmailCodePreRegister = async (param = {}, callBack) => {
    await http.post(`/newapi/tax/auth/register/email/code`, param).then(({ data: res }) => {
      callBack && callBack(res);
    });
};

/**
 * User registration API
 * @param {Object} param - Registration parameters object containing email, password, etc.
 * @param {Function} callBack - Callback function after successful registration
 */
export const Register = async (param = {}, callBack) => {
    // 使用纯 RSA 加密密码
    const encryptedPassword = encryptPasswordField(param.password);

    const registerData = {
      ...param,
      password: encryptedPassword,
      device: getDeviceInfo()
    };

    await http.post(`/newapi/tax/auth/register`, registerData).then(({ data: res }) => {
      callBack && callBack(res);
    });
};

/**
 * Validate invite code
 * @param {Object} param - Parameter object containing inviteCode
 * @param {Function} callBack - Callback function after validation
 */
export const checkInviteCode = async (param = {}, callBack) => {
    await http.post(`/newapi/tax/auth/checkInviteCode/${param?.inviteCode}`, param).then(({ data: res }) => {
      callBack && callBack(res);
    });
};

/**
 * Refresh user token
 * @param {Object} param - Parameters needed for token refresh
 * @param {Object} config - Request configuration
 * @param {Function} callBack - Callback function after successful refresh
 */
export const auth_refresh = async (param, config, callBack) => {
  const url = '/newapi/tax/auth/refresh';
  try {
    const response = await http.post(url, param, { ...config });
    const result = response.data;
    if (callBack) {
      callBack(result);
    }
    return result;
  } catch (error) {
    throw error;
  }
}

export default AUTH_API; 